export const HOMEPAGE_CREATE_GAME_CARD_TITLES = [
    'The world is yours to conquer',
    'Ready to rule the world?',
    'Your empire awaits',
    'Claim your territory',
    'Choose a map. Start a war.',
    'Gather your rivals',
    'Let the conquest begin',
    'A new battle awaits',
    'Build alliances. Break them later.',
    'Friends today. Enemies by turn three.',
];

export const HOMEPAGE_CREATE_GAME_CARD_SUBTITLES = [
    'Stake your claim, rally your rivals, and conquer the map.',
    'Gather your friends and battle for control of the world.',
    'Call your rivals. Choose your battlefield. Begin the conquest.',
    'Challenge your friends and fight for global domination.',
    'Raise an army, forge alliances, and seize the world.',
    'Pick your battlefield and invite your friends to war.',
    'Gather your rivals—the battle for the world starts now.',
    'Create the battlefield. Invite the opposition. Claim victory.',
    'Your rivals are waiting. Start the battle.',
    'Someone has to rule the world. Why not you?',
]

export function getRandomHomepageCreateGameCardTitle(): string {
    return HOMEPAGE_CREATE_GAME_CARD_TITLES[Math.floor(Math.random() * HOMEPAGE_CREATE_GAME_CARD_TITLES.length)];
}

export function getRandomHomepageCreateGameCardSubtitle(): string {
    return HOMEPAGE_CREATE_GAME_CARD_SUBTITLES[Math.floor(Math.random() * HOMEPAGE_CREATE_GAME_CARD_SUBTITLES.length)];
}
